<template>
    <div class="flex-grow-1">
        <div
            id="EChartTemplate"
            ref="agriEcoDev"
            :style="{ width: '100%', height: chartHeight + 'px' }"
        ></div>
    </div>
</template>

<script>
import * as echarts from "echarts";

export default {
    props: {
        chartHeight: Number,
        chartData: Object,
        chartType: String,
        chartName: String,
        isOpen: Boolean,
    },
    data() {
        return {
            chart: null,
        };
    },
    watch: {
        chartData(newVal) {
            this.processData(newVal);
        },
        isOpen: {
            immediate: true,
            handler(newVal) {
                if (newVal) {
                    this.$nextTick(() => {
                        if (this.chart) this.chart.resize();
                    });
                }
            },
        },
    },
    mounted() {
        this.chart = echarts.init(this.$refs.agriEcoDev);

        if (this.chartData && this.chartData.data) {
            this.processData(this.chartData);
        }

        window.addEventListener("resize", () => {
            if (this.chart) this.chart.resize();
        });
    },
    methods: {
        processData(data) {
            if (!this.chart || !data?.data || !data?.x_axis) return;

            switch (this.chartType) {
                case "line_chart":
                    const series = [
                        {
                            data: data.data,
                            type: "line",
                            name: "Average",
                            showSymbol: true,
                            symbolSize: 6,
                            itemStyle: {
                                opacity: 0,
                            },
                            smooth: true,
                            lineStyle: {
                                width: 3,
                            },
                            markLine: {
                                symbol: "none",
                                data: [
                                    {
                                        xAxis: "0s",
                                        name: "Zero Line",
                                    },
                                ],
                                lineStyle: {
                                    type: "solid",
                                    width: 2,
                                },
                                label: {
                                    show: false,
                                },
                            },
                            emphasis: {
                                focus: "series",
                                lineStyle: {
                                    width: 3,
                                    opacity: 1,
                                },
                            },
                        },
                    ];

                    const option = {
                        grid: {
                            top: 30,
                            bottom: 0,
                            right: 30,
                            left: "2%",
                            containLabel: true,
                        },
                        tooltip: {
                            trigger: "item",
                            triggerOn: "mousemove",
                            axisPointer: {
                                type: "line",
                            },
                            formatter: (params) => {
                                if (params.componentType === "markLine") return;
                                const value = params.value;
                                const xLabel = params.name;
                                const seriesInfo = params.seriesName;
                                if (params.seriesName === "Average") {
                                    return `<b>${seriesInfo}</b><br/>
                            <b>Time: </b>${xLabel}<br/>
                            <b>Value: </b>${value.toFixed(2)}<br/>`;
                                }
                                const ticket = seriesInfo.split(" ")[0];
                                const symbol = seriesInfo.split(" ")[1];
                                const typeName = seriesInfo.split(" ")[2];

                                return `<b>Ticket: </b>${ticket}<br/>
                        <b>Symbol: </b>${symbol}<br/>
                        <b>Type: </b>${typeName.replaceAll("-", " ")}<br/>
                        <b>Time: </b>${xLabel}<br/>
                        <b>Value: </b>${value.toFixed(2)}<br/>`;
                            },
                        },
                        xAxis: {
                            type: "category",
                            boundaryGap: false,
                            data: data.x_axis,
                        },
                        yAxis: {
                            name: "DPM",
                            type: "value",
                        },
                        series,
                    };

                    this.chart.setOption(option);
                    this.chart.resize({ height: this.chartHeight });
                    break;
                default:
                    break;
            }
        },
    },
};
</script>
